import { ExamplesSearchModel } from './types/ExamplesSearchModel';

export const formatter = new Intl.NumberFormat('en-US', {});

export const countNumQueries = (value: ExamplesSearchModel) => {
  const metadataCount = Object.entries(value.metadata ?? {}).filter(
    ([, v]) => v !== undefined && v !== ''
  ).length;
  const fullTextCount = (value.full_text ?? []).length;
  return metadataCount + fullTextCount;
};
